module.exports = __webpack_public_path__ + "static/media/scale.b50963e6.gif";